module.exports = "pegasus/assets/tech/valentine/100.png";